import { EnumSchema } from '../metadata-schema';

export const Niveau: EnumSchema = {
	"type": "string",
	"title": "Niveau",
	"enum": [
		"te breed",
		"OND",
		"VSO",
		"PrO",
		"VMBO b",
		"VMBO b / k",
		"VMBO k",
		"VMBO k / (g)t",
		"VMBO (g)t",
		"VMBO (g)t / HAVO",
		"VMBO (g)t / HAVO / VWO",
		"VMBO",
		"VMBO / HAVO",
		"VMBO / HAVO / VWO",
		"HAVO",
		"HAVO / VWO",
		"VWO"
	]
};
